<template>
  <div class="lang-box">
    <slot v-if="$slots.default"></slot>
    <div v-else class="lang-box-inputs">
      <SpForm
        ref="langForm"
        v-model="form"
        v-loading="loading"
        show-message
        :class="locale"
        label-width="auto"
        :form-list="formList"
        :submit="false"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: 'SpLanguage',
  model: {
    prop: 'value',
    event: 'update'
  },
  props: {
    value: {
      type: Object
    },
    type: {
      type: String,
      default: 'input'
    },
    required: {
        type: Boolean,
        default: false
    },
    message:{
        type:String,
        default:'请输入'
    },
    placeholder: String
  },
  data() {
    return {
      loading: false,
      form: {
        'zh-CN': '',
        'en-CN': ''
      }
    }
  },
  watch:{
    value:{
        handler(newVal){
            this.form['zh-CN'] = newVal['zh-CN']?.attribute_value || ''
            this.form['en-CN'] = newVal['en-CN']?.attribute_value || ''
        },
        deep: true,
        immediate: true
    },
    form:{
        handler(newVal){
                this.$emit('update', {
                    ...this.value,
                    'en-CN': { ...this.value['en-CN'], attribute_value: newVal['en-CN'] },
                    'zh-CN': { ...this.value['zh-CN'], attribute_value: newVal['zh-CN'] }
                })
        },
        deep: true,  
    }
  },
  computed: {
    locale(){
        return this.$i18n.locale
    },
    formList() {
      let list = [
        {
          type: this.type,
          display: 'block',
          required: this.required,
          placeholder: this.placeholder,
          message: this.message,
        },
        {
          type: this.type,
          required: this.required,
          placeholder: this.placeholder,
          display: 'block',
          message: ' ',
        }
      ]
      if (this.locale === 'zh') {
        list[0].key = 'zh-CN'
        list[1].key = 'en-CN'
      } else {
        list[0].key = 'en-CN'
        list[1].key = 'zh-CN'
      }
      return list
    }
  }
}
</script>
<style lang="scss">
.lang-box {
  display: flex;
  align-items: flex-start;
  &-inputs {
    .sp-form{
        &.zh{
            .el-form-item:nth-child(2){
                .el-input,.el-textarea{
                    position: relative;
                    &::after{
                        content:'\82f1';
                        position: absolute;
                        top: 0;
                        right: 10px;
                        color: var(--themeColor);
                    }
                }
                .el-textarea{
                    &::after{
                        top: auto;
                        bottom: 0;
                    }
                }
            }
        }
        &.en{
            .el-form-item:nth-child(2){
                .el-input,.el-textarea{
                    position: relative;
                    &::after{
                        content:'\4e2d';
                        position: absolute;
                        top: 0;
                        right: 10px;
                        color: var(--themeColor);
                    }
                }
                .el-textarea{
                    &::after{
                        top: auto;
                        bottom: 0;
                    }
                }
            }
        }
        .el-form-item{
            &:nth-child(2){
                .el-input__suffix{
                    right: 25px;
                }
                margin-bottom: 4px;
            }
            .el-input__inner:focus {
                border-color: rgba(var(--themeColorRgb), 0.8);
            }
            &.is-error .el-input__inner{
                border-color: #F56C6C;
            }
        } 
    } 
    width: 100%;
  }
}
</style>
